// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"65":"video-pause","464":"search","485":"anchor-nav","520":"tabs","598":"hang-punctuation","695":"primary-nav","721":"offSiteLinks","773":"people-search","959":"department-menu","972":"news-search","988":"event-search"}[chunkId] || chunkId) + ".js";
};